import React from 'react';
import './styles.scss';

const BundleLabel = ({ ticketsCount, is341 = false }) => {
  // if (ticketsCount === 25) {
  //   return (
  //     <div className="single-bundle-card__ticket-label single-bundle-card__ticket-label--red">
  //       MOST POPULAR
  //     </div>
  //   );
  // }

  if (ticketsCount >= 50) {
    return (
      <div
        className={[
          'single-bundle-card__ticket-label',
          'single-bundle-card__ticket-label--green',
          is341 && 'single-bundle-card__ticket-label--341',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        BEST VALUE BUNDLE
      </div>
    );
  }

  return null;
};

export default BundleLabel;
